import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Component({
  selector: 'app-customer-register',
  templateUrl: './customer-register.component.html',
  styleUrls: ['./customer-register.component.scss']
})
export class CustomerRegisterComponent implements OnInit {
  model: any = { firstName: '', lastName: '', email: '', mobileNo: '', password: '' };

  constructor(private auth: AuthenticationService, private route: ActivatedRoute, private router: Router) {}

  loadPageData(): void {}

  register(): void {
    this.auth.registerCustomer(this.model).subscribe(() => {
      const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/customer/dashboard';
      this.router.navigateByUrl(returnUrl);
    });
  }

  ngOnInit(): void {
    this.loadPageData();
  }
}
